import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';
import { getInitialTheme, setTheme } from '../../lib/theme';
import { Button } from './index';

/**
 * ThemeToggle — TASK-10
 *
 * Component to switch between light and dark themes.
 * Integrates with lib/theme.ts for persistence.
 */
export function ThemeToggle() {
  const [theme, setInternalTheme] = useState(getInitialTheme());

  useEffect(() => {
    // Sync with state on mount (though main.tsx handles early application)
    setTheme(theme);
  }, [theme]);

  const toggle = () => {
    const nextTheme = theme === 'light' ? 'dark' : 'light';
    setInternalTheme(nextTheme);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggle}
      title={theme === 'light' ? 'Activar modo oscuro' : 'Activar modo claro'}
      data-testid="theme-toggle"
      className="text-content-tertiary hover:text-primary-600 transition-colors"
    >
      {theme === 'light' ? (
        <Moon className="h-5 w-5" />
      ) : (
        <Sun className="h-5 w-5 text-amber-500" />
      )}
    </Button>
  );
}
